import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import { parseAsArrayOf, parseAsString, useQueryStates } from 'nuqs';
export type SOSFilingsQueryParams = {
  filingsStates: string[];
};
const defaultQueryParams: SOSFilingsQueryParams = {
  filingsStates: []
};
const useSOSFilingStatesQueryParams = () => {
  const $ = _c(12);
  const router = useRouter();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      filings_states: parseAsArrayOf(parseAsString).withDefault(defaultQueryParams.filingsStates)
    };
    t1 = {
      history: "push",
      clearOnDefault: true
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const [queryParams, setQueryParams] = useQueryStates(t0, t1);
  let push;
  let values;
  if ($[2] !== queryParams.filings_states || $[3] !== setQueryParams) {
    push = newQuery => {
      const updated = {
        ...values,
        ...newQuery
      };
      setQueryParams({
        filings_states: updated.filingsStates ?? defaultQueryParams.filingsStates
      });
    };
    values = {
      filingsStates: queryParams.filings_states
    };
    $[2] = queryParams.filings_states;
    $[3] = setQueryParams;
    $[4] = push;
    $[5] = values;
  } else {
    push = $[4];
    values = $[5];
  }
  const filtersCount = values.filingsStates.length;
  const hasFilters = filtersCount > 0;
  let t2;
  if ($[6] !== filtersCount || $[7] !== hasFilters || $[8] !== push || $[9] !== router.isReady || $[10] !== values) {
    t2 = {
      isReady: router.isReady,
      push,
      filtersCount,
      values,
      hasFilters
    };
    $[6] = filtersCount;
    $[7] = hasFilters;
    $[8] = push;
    $[9] = router.isReady;
    $[10] = values;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
export default useSOSFilingStatesQueryParams;